import React, { useState } from "react";
import { db } from "../../firebase"; // ตรวจสอบ path ให้ตรงกับโปรเจกต์คุณ
import { updateDoc, doc } from "firebase/firestore";

const MembersTab = ({ trip, theme, onUpdateTrip, isDarkMode }) => {
  const [editingId, setEditingId] = useState(null);
  const [isAdding, setIsAdding] = useState(false);

  const initialFormState = {
    thaiName: "",
    engName: "",
    phone: "",
    lineId: "",
    email: "",
    emergencyContact: "",
  };

  const [formData, setFormData] = useState(initialFormState);
  const [allergies, setAllergies] = useState([]); // แยก state สำหรับลิสต์อาหารที่แพ้
  const [newAllergy, setNewAllergy] = useState("");

  // ฟังก์ชันเพิ่มอาหารที่แพ้
  const handleAddAllergy = (e) => {
    e.preventDefault();
    if (newAllergy.trim() && !allergies.includes(newAllergy.trim())) {
      setAllergies([...allergies, newAllergy.trim()]);
      setNewAllergy("");
    }
  };

  // ฟังก์ชันลบอาหารที่แพ้
  const handleRemoveAllergy = (allergyToRemove) => {
    setAllergies(allergies.filter((item) => item !== allergyToRemove));
  };

  const handleEditClick = (member) => {
    setFormData({
      thaiName: member.thaiName || "",
      engName: member.engName || "",
      phone: member.phone || "",
      lineId: member.lineId || "",
      email: member.email || "",
      emergencyContact: member.emergencyContact || "",
    });
    setAllergies(member.allergies || []);
    setEditingId(member.id);
    setIsAdding(false);
  };

  const handleCancel = () => {
    setEditingId(null);
    setIsAdding(false);
    setFormData(initialFormState);
    setAllergies([]);
    setNewAllergy("");
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      const memberData = {
        ...formData,
        allergies: allergies,
        id: editingId || `member_${Date.now()}`,
      };

      let newList;
      if (editingId) {
        newList = (trip.members || []).map((m) =>
          m.id === editingId ? memberData : m
        );
      } else {
        newList = [...(trip.members || []), memberData];
      }

      await updateDoc(doc(db, "trips", trip.id), { members: newList });
      onUpdateTrip(newList, "members");
      handleCancel();
    } catch (error) {
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("คุณต้องการลบข้อมูลผู้เดินทางนี้ใช่หรือไม่?")) {
      const newList = (trip.members || []).filter((m) => m.id !== id);
      await updateDoc(doc(db, "trips", trip.id), { members: newList });
      onUpdateTrip(newList, "members");
    }
  };

  const inputStyle = {
    padding: "10px 12px",
    borderRadius: "8px",
    border: `1px solid ${isDarkMode ? "#444" : "#ddd"}`,
    backgroundColor: isDarkMode ? "#2c2c2c" : "#fff",
    color: isDarkMode ? "#fff" : "#000",
    fontSize: "14px",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontSize: "12px",
    fontWeight: "bold",
    color: isDarkMode ? "#aaa" : "#666",
    marginBottom: "5px",
    display: "block",
  };

  const formBgStyle = {
    backgroundColor: isDarkMode ? "#1e1e1e" : "#f8f9fa",
    borderRadius: "12px",
    padding: "20px",
    border: `1px solid ${theme?.border || (isDarkMode ? "#333" : "#ddd")}`,
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    marginBottom: "15px",
  };

  const cardStyle = {
    backgroundColor: theme?.cardBg || (isDarkMode ? "#1e1e1e" : "#fff"),
    borderRadius: "12px",
    padding: "20px",
    border: `1px solid ${theme?.border || "#eee"}`,
    position: "relative",
    marginBottom: "15px",
  };

  return (
    <div style={{ paddingBottom: "30px", maxWidth: "800px", margin: "0 auto" }}>
      {/* ================= LIST OF MEMBERS ================= */}
      {!isAdding && !editingId && (trip.members || []).length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
          {trip.members.map((member) => (
            <div key={member.id} style={cardStyle}>
              <button
                onClick={() => handleEditClick(member)}
                style={{
                  position: "absolute",
                  top: "15px",
                  right: "15px",
                  background: "none",
                  border: "none",
                  color: "#888",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                •••
              </button>

              <div style={{ display: "flex", alignItems: "center", gap: "15px", marginBottom: "15px" }}>
                <div
                  style={{
                    width: "50px",
                    height: "50px",
                    borderRadius: "50%",
                    backgroundColor: "#a855f7",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "20px",
                    fontWeight: "bold",
                    flexShrink: 0
                  }}
                >
                  {member.thaiName ? member.thaiName.charAt(0) : "👤"}
                </div>
                <div>
                  <div style={{ fontSize: "18px", fontWeight: "bold", color: theme?.text }}>
                    {member.thaiName}
                  </div>
                  <div style={{ fontSize: "13px", color: "#888" }}>
                    {member.engName || "ไม่ระบุชื่อภาษาอังกฤษ"}
                  </div>
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "10px", fontSize: "14px", color: theme?.text }}>
                <div>📞 <strong>เบอร์โทร:</strong> {member.phone || "-"}</div>
                <div>💬 <strong>LINE ID:</strong> {member.lineId || "-"}</div>
                <div>📧 <strong>อีเมล:</strong> {member.email || "-"}</div>
                <div>🚨 <strong>เบอร์ญาติฉุกเฉิน:</strong> <span style={{ color: "#e74c3c", fontWeight: "bold" }}>{member.emergencyContact || "-"}</span></div>
              </div>

              {member.allergies && member.allergies.length > 0 && (
                <div style={{ marginTop: "15px", paddingTop: "15px", borderTop: `1px dashed ${isDarkMode ? "#444" : "#eee"}` }}>
                  <div style={{ fontSize: "12px", fontWeight: "bold", color: "#e67e22", marginBottom: "8px" }}>
                    ⚠️ อาหารที่แพ้ / ข้อควรระวัง:
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                    {member.allergies.map((allergy, idx) => (
                      <span key={idx} style={{
                        backgroundColor: "rgba(230, 126, 34, 0.1)",
                        color: "#e67e22",
                        padding: "4px 10px",
                        borderRadius: "999px",
                        fontSize: "12px",
                        fontWeight: "600"
                      }}>
                        {allergy}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {/* ================= FORM (ADD/EDIT) ================= */}
      {(isAdding || editingId) && (
        <div style={{ ...formBgStyle, border: isAdding ? `2px dashed #a855f7` : formBgStyle.border }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "20px" }}>
            <h4 style={{ margin: 0, color: "#a855f7" }}>
              {editingId ? "✏️ แก้ไขข้อมูลผู้เดินทาง" : "👤 เพิ่มผู้เดินทางใหม่"}
            </h4>
            {editingId && (
              <button
                type="button"
                onClick={() => handleDelete(editingId)}
                style={{ background: "none", border: "none", color: "#e74c3c", cursor: "pointer", fontSize: "18px" }}
              >
                🗑️
              </button>
            )}
          </div>

          <form onSubmit={handleSave}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "15px" }}>
              <div>
                <label style={labelStyle}>ชื่อ-นามสกุล (ไทย)</label>
                <input
                  type="text"
                  placeholder="เช่น สมชาย ใจดี"
                  value={formData.thaiName}
                  onChange={(e) => setFormData({ ...formData, thaiName: e.target.value })}
                  style={inputStyle}
                  required
                />
              </div>
              <div>
                <label style={labelStyle}>ชื่อ-นามสกุล (English - ตรงตามพาสปอร์ต)</label>
                <input
                  type="text"
                  placeholder="e.g. Somchai Jaidee"
                  value={formData.engName}
                  onChange={(e) => setFormData({ ...formData, engName: e.target.value })}
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "15px", marginBottom: "15px" }}>
              <div>
                <label style={labelStyle}>📱 เบอร์โทรศัพท์ (ไทย)</label>
                <input
                  type="tel"
                  placeholder="08X-XXX-XXXX"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>💬 LINE ID</label>
                <input
                  type="text"
                  placeholder="ID สำหรับติดต่อ"
                  value={formData.lineId}
                  onChange={(e) => setFormData({ ...formData, lineId: e.target.value })}
                  style={inputStyle}
                />
              </div>
              <div>
                <label style={labelStyle}>📧 Email</label>
                <input
                  type="email"
                  placeholder="example@mail.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  style={inputStyle}
                />
              </div>
            </div>

            <div style={{ marginBottom: "20px", padding: "15px", backgroundColor: isDarkMode ? "#2c2c2c" : "#fff1f0", borderRadius: "8px", border: `1px solid ${isDarkMode ? "#444" : "#ffccc7"}` }}>
              <label style={{ ...labelStyle, color: "#e74c3c" }}>🚨 เบอร์โทรติดต่อฉุกเฉิน (ญาติที่ไทย)</label>
              <input
                type="text"
                placeholder="ชื่อญาติ และ เบอร์โทร (เช่น คุณแม่: 081-xxx-xxxx)"
                value={formData.emergencyContact}
                onChange={(e) => setFormData({ ...formData, emergencyContact: e.target.value })}
                style={inputStyle}
              />
            </div>

            {/* ส่วนของการเพิ่มอาหารที่แพ้แบบ List */}
            <div style={{ marginBottom: "20px" }}>
              <label style={labelStyle}>⚠️ อาหารที่แพ้ / ข้อควรระวัง (ถ้ามี)</label>
              <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
                <input
                  type="text"
                  placeholder="เช่น แพ้กุ้ง, ไม่กินเนื้อวัว, แพ้ถั่วลิสง"
                  value={newAllergy}
                  onChange={(e) => setNewAllergy(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddAllergy(e);
                    }
                  }}
                  style={inputStyle}
                />
                <button
                  type="button"
                  onClick={handleAddAllergy}
                  style={{
                    padding: "0 15px",
                    backgroundColor: "#e67e22",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    flexShrink: 0
                  }}
                >
                  + เพิ่ม
                </button>
              </div>
              
              {/* แสดง List อาหารที่แพ้ */}
              <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                {allergies.map((allergy, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor: isDarkMode ? "#444" : "#f1f5f9",
                      padding: "6px 12px",
                      borderRadius: "999px",
                      fontSize: "13px",
                      color: isDarkMode ? "#ddd" : "#333",
                    }}
                  >
                    <span>{allergy}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveAllergy(allergy)}
                      style={{
                        background: "none",
                        border: "none",
                        color: "#e74c3c",
                        cursor: "pointer",
                        padding: 0,
                        fontSize: "14px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={handleCancel}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: `1px solid ${isDarkMode ? "#555" : "#ccc"}`,
                  background: isDarkMode ? "#333" : "white",
                  color: isDarkMode ? "#fff" : "#000",
                  cursor: "pointer",
                }}
              >
                ยกเลิก
              </button>
              <button
                type="submit"
                style={{
                  padding: "8px 24px",
                  borderRadius: "8px",
                  border: "none",
                  background: "#a855f7",
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                บันทึก
              </button>
            </div>
          </form>
        </div>
      )}

      {/* ปุ่มเพิ่มผู้เดินทาง */}
      {!isAdding && !editingId && (
        <button
          onClick={() => {
            setFormData(initialFormState);
            setAllergies([]);
            setIsAdding(true);
          }}
          style={{
            padding: "15px",
            borderRadius: "12px",
            border: `1px dashed ${isDarkMode ? "#555" : "#bbb"}`,
            background: "transparent",
            color: isDarkMode ? "#aaa" : "#666",
            fontSize: "15px",
            fontWeight: "bold",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginTop: "10px",
            width: "100%",
            justifyContent: "center",
            transition: "0.2s",
          }}
        >
          ➕ เพิ่มผู้เดินทาง
        </button>
      )}
    </div>
  );
};

export default MembersTab;